const SECONDS_IN_MINUTE = 60;
const SECONDS_IN_HOUR = SECONDS_IN_MINUTE * 60;

const format = (time: number): string => {
  const hours = Math.floor(time / SECONDS_IN_HOUR);
  const minutes = Math.floor((time - hours * SECONDS_IN_HOUR) / SECONDS_IN_MINUTE);
  const seconds = Math.floor(time - hours * SECONDS_IN_HOUR - minutes * SECONDS_IN_MINUTE);

  const formattedSeconds = seconds < 10 ? `0${seconds}` : `${seconds}`;
  const formattedMinutes = minutes < 10 ? `0${minutes}` : `${minutes}`;

  if (hours) {
    return `${hours}:${formattedMinutes}:${formattedSeconds}`;
  }
  if (minutes) {
    return `${minutes}:${formattedSeconds}`;
  }
  return `0:${formattedSeconds}`;
};

export const TimeFormatter = {
  format
};
